import React from 'react';
// import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
// import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
// import './styles.css';

const useStyles = makeStyles((theme) => ({
    question: {
        color: '#111',
        fontFamily: 'Rubik',
        fontSize: '15px',
        fontWeight: 500,
    },
    subheading: {
        fontSize: '12px',
        color: '#4c4c4d',
        fontFamily: 'Rubik',
        fontWeight: 500,
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

const BankVerification = () => {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        name: '',
        pan: '',
        value: '',
    });

    return (
        <Grid container spacing={3} className="main-container">
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Obtain a list of all types of accounts with banks and financial institutions maintained by the client
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Obtain sample account statements</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Verify sample transactions in the statements with the books of accounts
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Verify reconciliations with the bank statements</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>Obtain balance confirmation letters at the end of the audit period</Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Prepare the schedule of all the accounts documenting the confirmation and observations
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
            <Grid item xs={12} sm={12}>
                <Typography className={classes.question}>
                    Obtain information on income from deposit accounts and verify suitable accounting treatment
                </Typography>
                <Typography className={classes.subheading}>ET Reviews</Typography>
            </Grid>
            <Grid item xs={6} sm={6}>
                <div>
                    <FormControl component="fieldset">
                        <RadioGroup disabled defaultValue="Yes" aria-label="yes-no" name="customized-radios" className="radio-option mb15">
                            <ul className={classes.inlineDisplay}>
                                <li>
                                    <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" />
                                </li>
                                <li>
                                    <FormControlLabel value="No" control={<StyledRadio />} label="No" />
                                </li>
                                <li>
                                    <FormControlLabel value="Na" control={<StyledRadio />} label="NA" />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                    <InputLabel className="lbl" htmlFor="startdate" shrink>
                        Select Date <span style={{ color: '#ff0a047a' }}>*</span>
                    </InputLabel>
                    <Input
                        type="date"
                        className="bottom"
                        name="startdate"
                        // onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        // value={formik.values.startdate}
                        inputProps={{ max: '9999-12-31' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Grid>{' '}
        </Grid>
    );
};

export default BankVerification;
